import { Button, Typography } from '@breetometer/components';
import type { IWalletAddress } from 'BreetHelpers';
import { useSavedWalletAddressApi } from 'BreetHooks';
import { useCallback } from 'react';

import WalletAddressTable from './WalletAddress.Table';
import WalletAddressesEmpty from './WalletAddresses.Empty';
import type { IWalletAddressesSavedProps } from './WalletAddresses.helpers';

const WalletAddressesSaved = ({
	onAddNewAddress,
	onSelectAddress,
	onManageAddress,
	selectedWalletAddress,
	onButtonClick,
	isButtonDisabled,
}: IWalletAddressesSavedProps) => {
	const { savedWalletAddresses, isSavedWalletAddressesEmpty } = useSavedWalletAddressApi();

	const handleItemSelect = useCallback(
		(item: IWalletAddress) => () => {
			onSelectAddress(item);
		},
		[onSelectAddress]
	);

	if (isSavedWalletAddressesEmpty) return <WalletAddressesEmpty />;

	return (
		<div>
			<div className='savedwalletaddress-header'>
				<Typography className='color-primary-50'>Select Wallet Address</Typography>
			</div>

			<div className='savedwalletaddress bg-primary-500 border-dark-navy'>
				<WalletAddressTable
					data={savedWalletAddresses}
					onSelect={handleItemSelect}
					selectedWalletAddress={selectedWalletAddress}
				/>
			</div>
			<div className='savedwalletaddress-cta'>
				{savedWalletAddresses.length < 3 && (
					<Button
						label='Add New Address'
						variant='primary'
						className='savedwalletaddress_cta add-new-btn bg-primary-400 bg-primary-400-hover tertiary-semi-hover'
						onClick={onAddNewAddress}
						type='button'
					/>
				)}

				<Button
					label='Manage Address'
					variant='tertiary'
					className='savedwalletaddress_cta manage-btn theme-background-none border-dark-navy bg-primary-400-hover color-neutral-50-hover outline-hover'
					onClick={onManageAddress}
					type='button'
				/>
			</div>

			<div className='payment-request-form_usdDestination_send-crypto-cta mt-5'>
				<Button
					label='Continue'
					type='button'
					onClick={onButtonClick}
					disabled={isButtonDisabled}
					className='primary-hover'
				/>
			</div>
		</div>
	);
};

export default WalletAddressesSaved;
